/* RANI CUSTOM — Mobil menü: KATMANLI KAYDIRMALI PANEL.
   Kullanıcı kararları:
     • Kategoriler kapalı gelir.
     • Ana kategoriye basınca liste aşağı açılmaz; panel yandan kayar.
     • Panel başlığında ana kategori: kalın + tıklanabilir (kendisi de koleksiyon).
     • Seviyeler arası geçiş ANİMASYONLU — ileri/geri kayar, "çat" diye değişmez.
   Mimari: her seviye kendi katmanı; panel çekmece içeriğinin üstüne biner,
   orijinal menü DOM'una dokunulmaz (veri oradan okunur). */
(function () {
  if (typeof window === 'undefined') return;
  var MOBIL = function () { return window.innerWidth < 1200; };
  var SURE = 300; // CSS geçiş süresiyle aynı
  var panel = null, katmanlar = [];

  /* Bir kapsayıcının alt öğelerini oku */
  function altOgeler(kapsayici) {
    var liste = kapsayici.querySelector(':scope > ul');
    if (!liste) return [];
    return Array.prototype.map.call(liste.children, function (li) {
      var a = li.querySelector(':scope > a');
      if (!a) return null;
      var altUl = li.querySelector(':scope > ul');
      return {
        ad: (a.textContent || '').trim(),
        url: a.getAttribute('href') || '',
        altVar: !!(altUl && altUl.children.length),
        kaynak: li,
      };
    }).filter(Boolean);
  }

  function paneliKur() {
    var icerik = document.querySelector('.wt-drawer--nav .wt-drawer__content');
    if (!icerik || panel) return;
    panel = document.createElement('div');
    panel.className = 'rani-mm';
    icerik.appendChild(panel);
    var baslikSatiri = icerik.querySelector('.wt-drawer__title');
    var ust = baslikSatiri ? Math.round(baslikSatiri.getBoundingClientRect().height) : 56;
    panel.style.setProperty('--rani-mm-ust', (ust > 10 ? ust : 56) + 'px');
  }

  /* Yeni katman oluştur → sağdan kayarak gelir */
  function katmanEkle(kayit) {
    paneliKur();
    if (!panel) return;

    var kat = document.createElement('div');
    kat.className = 'rani-mm__kat';

    var bas = document.createElement('div');
    bas.className = 'rani-mm__bas';
    var geriBtn = document.createElement('button');
    geriBtn.type = 'button';
    geriBtn.className = 'rani-mm__geri';
    geriBtn.setAttribute('aria-label', 'Geri');
    geriBtn.textContent = '‹';
    geriBtn.addEventListener('click', function (e) { e.preventDefault(); geri(); });

    var baslik = document.createElement('a');
    baslik.className = 'rani-mm__baslik';
    var ad = document.createElement('span');
    ad.className = 'rani-mm__baslik-ad';
    ad.textContent = kayit.ad;
    baslik.appendChild(ad);
    if (kayit.url && kayit.url !== '#') {
      baslik.setAttribute('href', kayit.url);
      var tumu = document.createElement('span');
      tumu.className = 'rani-mm__tumu';
      tumu.textContent = 'Tümünü gör ›';
      baslik.appendChild(tumu);
    }
    bas.appendChild(geriBtn);
    bas.appendChild(baslik);

    var liste = document.createElement('ul');
    liste.className = 'rani-mm__liste';
    kayit.ogeler.forEach(function (o) {
      var li = document.createElement('li');
      li.className = 'rani-mm__oge';
      var a = document.createElement('a');
      a.className = 'rani-mm__link' + (o.altVar ? ' rani-mm__link--parent' : '');
      a.textContent = o.ad;
      if (o.url) a.setAttribute('href', o.url);
      if (o.altVar) {
        a.addEventListener('click', function (e) {
          e.preventDefault();
          katmanEkle({ ad: o.ad, url: o.url, ogeler: altOgeler(o.kaynak) });
        });
      }
      li.appendChild(a);
      liste.appendChild(li);
    });

    kat.appendChild(bas);
    kat.appendChild(liste);
    panel.appendChild(kat);

    /* Önceki katmanı geriye it (derinlik hissi) */
    var onceki = katmanlar[katmanlar.length - 1];
    if (onceki) onceki.classList.add('rani-mm__kat--geride');

    katmanlar.push(kat);
    panel.classList.add('rani-mm--acik');
    panel.parentElement.classList.add('rani-mm-aktif');

    /* Bir kare bekle → transition çalışsın (yoksa anında yerleşir) */
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { kat.classList.add('rani-mm__kat--acik'); });
    });
  }

  function geri() {
    var kat = katmanlar.pop();
    if (!kat) return;
    kat.classList.remove('rani-mm__kat--acik'); // sağa kayarak çıkar
    setTimeout(function () { if (kat.parentElement) kat.parentElement.removeChild(kat); }, SURE + 40);

    var alt = katmanlar[katmanlar.length - 1];
    if (alt) {
      alt.classList.remove('rani-mm__kat--geride'); // öne dön
    } else {
      panel.classList.remove('rani-mm--acik');
      panel.parentElement.classList.remove('rani-mm-aktif');
    }
  }

  function sifirla() {
    katmanlar.forEach(function (k) { if (k.parentElement) k.parentElement.removeChild(k); });
    katmanlar = [];
    if (panel) {
      panel.classList.remove('rani-mm--acik');
      panel.parentElement.classList.remove('rani-mm-aktif');
    }
  }

  function baglan() {
    var drawer = document.querySelector('.wt-drawer--nav');
    if (!drawer) return;
    paneliKur();
    drawer.querySelectorAll('.wt-page-nav-mega__list > li').forEach(function (li) {
      var a = li.querySelector(':scope > a');
      var wrapper = li.querySelector(':scope > .wt-page-nav-mega__sublist__wrapper');
      if (!a || !wrapper || li.dataset.raniMm) return;
      li.dataset.raniMm = '1';
      a.addEventListener('click', function (e) {
        if (!MOBIL()) return;
        e.preventDefault();
        e.stopPropagation();
        katmanEkle({ ad: a.textContent.trim(), url: a.getAttribute('href') || '', ogeler: altOgeler(wrapper) });
      }, true);
    });
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('.wt-drawer__close, .menu-drawer-overlay, [rel="toggle-menu"]')) {
      setTimeout(sifirla, 320);
    }
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', baglan);
  else baglan();
  window.addEventListener('resize', baglan);
})();
